import { z } from "zod"
import { UpdateGroupDuesDtoSchema, RecurrenceInterval } from "@mimber/schema"

const optionalPriceInCents = z
  .union([z.number(), z.string(), z.undefined(), z.null()])
  .transform((val) => {
    if (val === "" || val === undefined || val === null) return null
    return typeof val === "string" ? Number(val) : val
  })
  .pipe(
    z
      .number()
      .int("Dues price must be an integer number of cents")
      .min(0, "Dues price must be non-negative")
      .nullable()
  )

const optionalIntervalLengthFromString = z
  .union([z.number(), z.string(), z.undefined(), z.null()])
  .transform((val) => {
    if (val === "" || val === undefined || val === null) return null
    return typeof val === "string" ? Number(val) : val
  })
  .pipe(
    z
      .number()
      .int("Interval length must be an integer")
      .min(1, "Interval length must be at least 1")
      .nullable()
  )

/**
 * Form schema that extends the DTO schema with string-to-number transformations
 * for form inputs (text fields return strings that need to be converted)
 */
export const editGroupDuesSchema = UpdateGroupDuesDtoSchema.extend({
  duesPrice: optionalPriceInCents,
  duesIntervalLength: optionalIntervalLengthFromString,
  duesIntervalType: z.enum(RecurrenceInterval).nullable().optional(),
})

/**
 * Output type after transformation - this is what gets passed to onSubmit
 */
export type EditGroupDuesData = z.output<typeof editGroupDuesSchema>
